import React from 'react';
import { AlertTriangleIcon, ClockIcon } from 'lucide-react';
export function Testimonials() {
  return <section className="w-full py-12 bg-gray-50" data-id="element-266">
      <div className="max-w-4xl mx-auto px-4" data-id="element-267">
        <div className="bg-red-50 border-2 border-red-300 p-6 rounded-lg mb-12" data-id="element-268">
          <div className="flex items-center mb-4" data-id="element-269">
            <AlertTriangleIcon className="h-8 w-8 text-red-600 mr-3" data-id="element-270" />
            <h2 className="text-2xl md:text-3xl font-serif font-bold text-red-800" data-id="element-271">
              WARNUNG: Die Zeit läuft ab
            </h2>
          </div>
          <p className="text-lg text-red-800 font-bold mb-4" data-id="element-272">
            Jeden Tag des Wartens ist ein verlorener Tag Ihres echten Lebens.
          </p>
          <div className="bg-white p-4 rounded-md mb-4" data-id="element-273">
            <div className="flex items-center mb-2" data-id="element-274">
              <ClockIcon className="h-5 w-5 text-red-600 mr-2" data-id="element-275" />
              <p className="font-bold" data-id="element-276">Update 15. Juni 2025:</p>
            </div>
            <p data-id="element-277">
              Nachdem meine Geschichte in deutschen Gesundheitsforen viral ging,
              ist die Nachfrage explodiert.
            </p>
          </div>
          <ul className="space-y-3 mb-4" data-id="element-278">
            <li className="flex items-start" data-id="element-279">
              <span className="text-red-600 font-bold mr-2" data-id="element-280">⚠️</span>
              <span data-id="element-281">Nur noch wenige TianSole-Paare auf deutschem Lager</span>
            </li>
            <li className="flex items-start" data-id="element-282">
              <span className="text-red-600 font-bold mr-2" data-id="element-283">⚠️</span>
              <span data-id="element-284">Über 3.400 Deutsche bereits auf der Warteliste</span>
            </li>
            <li className="flex items-start" data-id="element-285">
              <span className="text-red-600 font-bold mr-2" data-id="element-286">⚠️</span>
              <span data-id="element-287">Nächste Lieferung erst in 8-10 Wochen erwartet</span>
            </li>
          </ul>
          <p className="font-bold text-red-800" data-id="element-288">
            Mein Rat: Prüfen Sie die Verfügbarkeit heute, oder warten Sie 2+
            Monate.
          </p>
          <a href="https://tiansole.de/products/tiansole" target="_blank" rel="noopener noreferrer" className="w-full md:w-auto px-6 py-3 bg-red-600 hover:bg-red-700 text-white font-bold rounded-lg shadow-lg transition-colors mt-4 flex items-center justify-center" aria-label="Verfügbarkeit auf TianSole.de prüfen" data-id="element-289">
            Jetzt Verfügbarkeit prüfen →
          </a>
        </div>
      </div>
    </section>;
}